/**
 * Shared types and enums for edit-rule components.
 * This file exists to break circular dependencies between condition-item.tsx and edit-rule-context.tsx
 */

import { type RTESuggestion } from '@bbkAdminComponents/rich-text-editor';

// TODO: Remove code that uses isNull, isUndefined, isBlank. It's been deprecated and should be removed
export enum NullishOperator {
  isNull = 'Generic.isNull',
  isUndefined = 'Generic.isUndefined',
  isBlank = 'Generic.isBlank',
  isNilOrEmpty = 'Generic.isNilOrEmpty',
  isNotNilOrEmpty = 'Generic.isNotNilOrEmpty',
}

export const nullishOperators: NullishOperator[] = [
  // TODO: Remove code that uses isNull, isUndefined, isBlank. It's been deprecated and should be removed
  NullishOperator.isNull,
  NullishOperator.isUndefined,
  NullishOperator.isBlank,
  NullishOperator.isNilOrEmpty,
  NullishOperator.isNotNilOrEmpty,
];

export type AudienceFact = Pick<
  RTESuggestion,
  'name' | 'val' | 'type' | 'is_lov' | 'field_name' | 'integration_id'
> & {
  operators?: string[];
  scope?: 'SUBSCRIPTION' | 'CUSTOMER';
  kind?: 'STANDARD' | 'CUSTOM';
  group?: string;
};

export type CustomOptionData = {
  label: string;
  icon: React.ReactNode;
  field: RTESuggestion;
  is_ai?: boolean;
};
